<script lang="tsx">
import { defineComponent, type PropType, type VNodeChild } from 'vue'
import { createNamespace } from '@bd/vue3-utils'
import { Help } from '-/Common/Help'
const [name, bem] = createNamespace('CommonTitle')
export default defineComponent({
  name,
  props: {
    help: {
      type: [String, Object, Array, Number, Boolean] as PropType<VNodeChild | JSX.Element | string>
    }
  },
  setup(props, { slots }) {
    return () => (
      <div class={bem()}>
        <div class={bem('text')}>{slots.default?.()}</div>
        {props.help ? <Help text={props.help} /> : null}
      </div>
    )
  }
})
</script>

<style lang="less">
.common-title {
  display: flex;
  align-items: center;
  position: relative;
  font-size: 14px;
}
</style>
